import React from 'react'

export default function FunnelChart3({ heading, Data }) {
    console.log("Data",Data)

    const eventsMap = Data?.events?.length > 0 ? (Data?.events || []).reduce((acc, item) => {
        acc[item.event] = item;
        return acc;
    }, {}) : [];
    

    return (
        <>
            <div className='Areachart-box'>
                <div className='topHeader'>
                    <div>
                        <h5>{heading}</h5>
                    </div>
                </div>
                <div className='customFunnel3'>

                    <div className='leftcomp'>
                        <div className='custombox'>
                            <div className='custom-path purple'>
                                <h5>Basic</h5>
                            </div>
                            <div className="contentDiv">
                                <div className='boxess rightborder'>
                                    <h5>Conversion</h5>
                                    <h6>{eventsMap["LOGIN_MOBILE"]?.percentage ?? 0}%</h6>
                                </div>
                                <div className="boxess">
                                    <h5>Count</h5>
                                    <h6>{eventsMap["LOGIN_MOBILE"]?.count ?? 0}</h6>
                                </div>
                                {/* <div className="boxess">
                                    <h5>Drop Off</h5>
                                    <h6>0%</h6>
                                </div> */}
                            </div>
                        </div>
                        <div className='custombox'>

                            <div className='custom-path darkgreen'>
                                <h5>KYC Verification</h5>
                            </div>
                            <div className="contentDiv">
                                <div className='boxess rightborder'>
                                    <h5>Conversion</h5>
                                    <h6>{eventsMap["PAN_KYC_SUCCESS"]?.percentage ?? 0}%</h6>
                                </div>
                                <div className="boxess ">
                                    <h5>Count</h5>
                                    <h6>{eventsMap["PAN_KYC_SUCCESS"]?.count ?? 0}</h6>
                                </div>
                                {/* <div className="boxess">
                                    <h5>Drop Off</h5>
                                    <h6>0%</h6>
                                </div> */}
                            </div>
                        </div>
                        <div className='custombox'>

                            <div className='custom-path blue'>
                                <h5>Eligibility Check</h5>
                            </div>
                            <div className="contentDiv">
                                <div className='boxess rightborder'>
                                    <h5>Conversion</h5>
                                    <h6>{eventsMap["DOCUMENTS_ADDED_SUCCESSFULLY"]?.percentage ?? 0}%</h6>
                                </div>
                                <div className="boxess ">
                                    <h5>Count</h5>
                                    <h6>{eventsMap["DOCUMENTS_ADDED_SUCCESSFULLY"]?.count ?? 0}</h6>
                                </div>
                                {/* <div className="boxess">
                                    <h5>Drop Off</h5>
                                    <h6>0%</h6>
                                </div> */}
                            </div>
                        </div>
                        <div className='custombox'>

                            <div className='custom-path yellow'>
                                <h5>Applications</h5>
                            </div>
                            <div className="contentDiv">
                                <div className='boxess rightborder'>
                                    <h5>Conversion</h5>
                                    <h6>{eventsMap["LOAN_FORM_COMPLETED"]?.percentage ?? 0}%</h6>
                                </div>
                                <div className="boxess ">
                                    <h5>Count</h5>
                                    <h6>{eventsMap["LOAN_FORM_COMPLETED"]?.count ?? 0}</h6>
                                </div>
                                {/* <div className="boxess">
                                    <h5>Drop Off</h5>
                                    <h6>5%</h6>
                                </div> */}
                            </div>
                        </div>
                        <div className='custombox'>

                            <div className='custom-path green'>
                                <h5>Disbursed</h5>
                            </div>
                            <div className="contentDiv">
                                <div className='boxess rightborder'>
                                    <h5>Conversion</h5>
                                    <h6>{Data?.leadInfo?.disbursedConversionRate ?? 0}%</h6>
                                </div>
                                <div className="boxess ">
                                    <h5>Count</h5>
                                    <h6>{Data?.leadInfo?.disbursedLeads ?? 0}</h6>
                                </div>
                                {/* <div className="boxess">
                                    <h5>Drop Off</h5>
                                    <h6>0%</h6>
                                </div> */}
                            </div>
                        </div>
                    </div>



                </div>
            </div>
        </>
    )
}
